import React from 'react'

import { useRecoilState } from 'recoil'

import { toastsState } from '../atoms'
import Toast from './Toast'

function Toasts() {
    const [toasts, setToasts] = useRecoilState(toastsState)

    const deleteToast = (thash: string) => {
        setToasts((curr) => {
            let a = curr.filter((e) => {
                return e.hash !== thash
            })
            return a
        })
    }

    const activeToasts = () => {
        for (let i = 0; i < toasts.length; i++) {
            const t = toasts[i]
            if (!t.dismiss) {
                return <Toast key={t.hash} type={t.type} hash={t.hash} open={t.dismiss ? false : true} onDelete={() => deleteToast(t.hash)} msg={t.msg}></Toast>
            }
        }
        return ''
    }

    return <div>{activeToasts()}</div>
}

export default Toasts
